import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import td from './td';
import th from './th';
import tr from './tr';

import './styles.scss';

export default function VoucherEditorTable({ className, empty, readOnly, sticky, ...props }) {
  return (
    <div className="table-container">
      <table
        className={classNames(
          'table table-bordered table-form table-form--fixed voucher-table-form',
          className,
          {
            'table-form--muted': readOnly,
            'table-sticky': sticky,
            'voucher-table-form--empty': empty,
          },
        )}
        {...props}
      />
    </div>
  );
}

VoucherEditorTable.propTypes = {
  className: PropTypes.string,
  empty: PropTypes.bool,
  readOnly: PropTypes.bool,
  sticky: PropTypes.bool,
};

VoucherEditorTable.td = td;
VoucherEditorTable.th = th;
VoucherEditorTable.tr = tr;
